import EmpHeaderSection from "../app/pannels/employer/common/emp-header";
import EmpSidebarSection from "../app/pannels/employer/common/emp-sidebar";
import YesNoPopup from "../app/common/popups/popup-yes-no";
import EmployerRoutes from "../routing/employer-routes";
import { popupType } from "../globals/constants";
import { useState } from "react";

function EmployerLayout() {
  const [sidebarActive, setSidebarActive] = useState(true);

  const handleSidebarCollapse = () => {
    setSidebarActive(!sidebarActive);
  };

  const handleMenuItemClick = () => {
    setSidebarActive(!sidebarActive);
  };

  return (
    <>
      <div className="page-wraper">
        <EmpHeaderSection
          onClick={handleSidebarCollapse}
          sidebarActive={sidebarActive}
        />
        <EmpSidebarSection
          sidebarActive={sidebarActive}
          onMenuItemClick={handleMenuItemClick}
        />

        <div id="content" className={sidebarActive ? "" : "active"}>
          <div className="content-admin-main">
            <EmployerRoutes />
          </div>
        </div>

        <YesNoPopup
          id="logout-dash-profile"
          type={popupType.LOGOUT}
          msg={"Do you want to Logout your profile?"}
        />
        <YesNoPopup
          id="logout-delete-profile"
          type={popupType.DELETE}
          msg={"Do you want to Delete the profile?"}
        />
        <YesNoPopup
          id="logout-delete-job"
          type={popupType.DELETE}
          msg={"Do you want to Delete the Job Posting?"}
        />
      </div>
    </>
  );
}

export default EmployerLayout;
